import React, { useState } from "react";
import { withTheme } from "@material-ui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Button, Card, CardActions, CardContent, Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import CustomInputForm from "../custom/CustomInput";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer, { CardPageItem, PageItem } from "../custom/Page";
import { changeSafeword } from "../actions/User";
import { showErrorMessage, showSuccessMessage } from "../actions/Alert";
import { useDispatch } from "react-redux";

const ChangeSafeWordForm = ({ handleSubmit, currentUser, history }) => {
  const [word, setWord] = useState("");
  const dispatch = useDispatch();

  const onSubmit = async (formValues) => {
    try {
      await changeSafeword(formValues);
      dispatch(showSuccessMessage("app.safeword.success"));
      history.push("/more");
    } catch (e) {
      dispatch(showErrorMessage("app.safeword.error"));
    }
  };

  const disabledButton = !word || word.length <= 2;
  const headerTitle = currentUser?.safeword ? "app.safeword.change" : "app.safeword.register";

  return (
    <>
      <PageContainer>
        <PageItem>
          <HeaderPageItem title={headerTitle} showBackButton destination="/more" />
        </PageItem>
        <PageItem>
          <CardPageItem raised>
            <CardContent>
              <Typography gutterBottom variant="body1">
                <FormattedMessage id="app.safeword.description" />
              </Typography>
              <Typography gutterBottom variant="body1">
                <FormattedHTMLMessage id="app.safeword.description2" />
              </Typography>
              <form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: 12, gap: 8 }}>
                <Field
                  name="safeword"
                  label="app.safeword"
                  type="text"
                  inputProps={{ maxLength: 24 }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  component={CustomInputForm}
                  onChange={(e) => setWord(e.target.value)}
                />
                <Button fullWidth id="bSubmitOrderForm" variant="contained" color="primary" type="submit" disabled={disabledButton}>
                  <FormattedMessage id="app.button.save" />
                </Button>
              </form>
            </CardContent>
          </CardPageItem>
        </PageItem>
      </PageContainer>
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentUser: state.user.user.me,
  };
}

export default compose(
  reduxForm({
    form: "changeSafeWord",
  }),
  connect(mapStateToProps),
  withTheme
)(ChangeSafeWordForm);
